export const PROGRESS_SUCCESS_VARIANT_PERCENTAGE = 60;
export const PROGRESS_COMPLETE_PERCENTAGE = 100;

export const COMPLETE_MESSAGE = '% Complete. Congrats—you’ve completed all required steps!';
export const INCOMPLETE_MESSAGE = '% Completed. Provide the missing details to get up and running.';

export const GO_LIVE_COVER_TITLE = 'Go Live Checklist';
